var Cirrus = (function (global) {
    'use strict';
    var Cirrus = function () {
        function bootstrap_notify(message, type, url, title) {
            try {
                if (
                    (type != 'info' && type != 'warning' && type != 'success' && type != 'danger') ||
                    typeof message != 'string'
                ) {
                    return false;
                }
                if (typeof title != 'undefined') {
                    if (typeof url != 'undefined') {
                        return $.notify({ title: title, message: message, url: url }, { type: type });
                    } else {
                        return $.notify({ title: title, message: message }, { type: type });
                    }
                } else {
                    if (typeof url != 'undefined') {
                        return $.notify({ message: message, url: url }, { type: type });
                    } else {
                        return $.notify({ message: message }, { type: type });
                    }
                }
            } catch (err) {
                console.log(err);
            }
            return false;
        }
        return {
            success: function (message, url, title) {
                return bootstrap_notify(message, 'success', url, title);
            },
            error: function (message, url, title) {
                return bootstrap_notify(message, 'danger', url, title);
            },
            log: function (message, url, title) {
                return bootstrap_notify(message, 'info', url, title);
            },
            warning: function (message, url, title) {
                return bootstrap_notify(message, 'warning', url, title);
            },
            message: function (message, type, url, title) {
                return bootstrap_notify(message, type, url, title);
            },
            confirm: function (title, text, type, verb, successCallback, dismissCallback) {
                if (typeof title == 'undefined') {
                    title = '';
                }
                if (typeof text == 'undefined') {
                    text = '';
                }
                if (typeof type == 'undefined') {
                    type = 'question';
                }
                var ConfirmButtonText = 'Yes, ' + verb + ' it!';
                if (verb.indexOf(' ') >= 0) {
                    ConfirmButtonText = verb;
                }

                swal({
                    title: title,
                    html: text,
                    type: type,
                    width: '700px',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: ConfirmButtonText,
                    cancelButtonText: 'No, cancel!',
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.value) {
                        // handle confirm
                        if (jQuery.isFunction(successCallback)) {
                            successCallback(result.value);
                        }
                    } else {
                        // handle dismiss, result.dismiss can be 'cancel', 'overlay', 'close', and 'timer'
                        if (jQuery.isFunction(dismissCallback)) {
                            dismissCallback();
                        }
                    }
                });
            },
            alert: function (title, text, type, successCallback, dismissCallback, wide = false, showCancel = true) {
                if (typeof title == 'undefined') {
                    title = '';
                }
                if (typeof text == 'undefined') {
                    text = '';
                }
                if (typeof type == 'undefined') {
                    type = 'question';
                }
                swal({
                    title: title,
                    html: text,
                    type: type,
                    allowOutsideClick: false,
                    showCancelButton: showCancel,
                    width: wide ? '700px' : '32rem',
                }).then((result) => {
                    if (result.value) {
                        // handle confirm
                        if (jQuery.isFunction(successCallback)) {
                            successCallback(result.value);
                        }
                    } else {
                        // handle dismiss, result.dismiss can be 'cancel', 'overlay', 'close', and 'timer'
                        if (jQuery.isFunction(dismissCallback)) {
                            dismissCallback();
                        }
                    }
                });
            },
            prompt: function (
                title,
                text,
                type,
                inputType,
                validate,
                validationType,
                successCallback,
                dismissCallback,
                defaultValue
            ) {
                if (typeof title == 'undefined') {
                    title = '';
                }
                if (typeof text == 'undefined') {
                    text = '';
                }
                if (typeof type == 'undefined') {
                    type = 'question';
                }
                var inputValidation = null;
                if (validate === true) {
                    inputValidation = (value) => {
                        return new Promise((resolve) => {
                            if (validationType === 'text') {
                                if (value === '') {
                                    resolve('A response is required.');
                                }
                                resolve();
                            } else if (validationType === 'number') {
                                if ($.isNumeric(value)) {
                                    resolve();
                                } else if (value === '') {
                                    resolve('A response is required.');
                                } else {
                                    resolve('You must enter numbers only.');
                                }
                            }
                            resolve('An unknown error occurred.');
                        });
                    };
                }
                swal({
                    title: title,
                    html: text,
                    type: type,
                    input: inputType,
                    inputValue: defaultValue,
                    showCancelButton: true,
                    confirmButtonText: 'Submit',
                    showLoaderOnConfirm: true,
                    preConfirm: (value) => {
                        return value;
                    },
                    allowOutsideClick: false,
                    inputValidator: inputValidation,
                    width: '70rem',
                }).then((result) => {
                    if (result.value) {
                        // handle confirm
                        if (jQuery.isFunction(successCallback)) {
                            successCallback(result.value);
                        }
                    } else {
                        // handle dismiss, result.dismiss can be 'cancel', 'overlay', 'close', and 'timer'
                        if (jQuery.isFunction(dismissCallback)) {
                            dismissCallback();
                        }
                    }
                });
            },
        };
    };

    global.cirrus = new Cirrus();
})(typeof window !== 'undefined' ? window : {});
